export default {
    aerial_hazard: {
        name: "Aerial Hazard",
        url: "sarcop_incident_support/aerial_hazard",
    },
    airport: {
        name: "Airport",
        url: "sarcop_incident_support/airport",
    },
    boo_camp: {
        name: "BoO Camp",
        url: "sarcop_incident_support/boo_camp",
    },
    casualty_collection_point: {
        name: "Casualty Collection Point",
        url: "sarcop_incident_support/casualty_collection_point",
    },
    drop_point: {
        name: "Drop Point",
        url: "sarcop_incident_support/drop_point",
    },
    extra_21: {
        name: "Extra 21",
        url: "sarcop_incident_support/extra_21",
    },
    extra_22: {
        name: "Extra 22",
        url: "sarcop_incident_support/extra_22",
    },
    extra_23: {
        name: "Extra 23",
        url: "sarcop_incident_support/extra_23",
    },
    extra_24: {
        name: "Extra 24",
        url: "sarcop_incident_support/extra_24",
    },
    helibase: {
        name: "Helibase",
        url: "sarcop_incident_support/helibase",
    },
    helispot: {
        name: "Helispot",
        url: "sarcop_incident_support/helispot",
    },
    incident_command_post: {
        name: "Incident Command Post",
        url: "sarcop_incident_support/incident_command_post",
    },
    internet_access: {
        name: "Internet Access",
        url: "sarcop_incident_support/internet_access",
    },
    lifeline_report: {
        name: "Lifeline Report",
        url: "sarcop_incident_support/lifeline_report",
    },
    medical: {
        name: "Medical",
        url: "sarcop_incident_support/medical",
    },
    other: {
        name: "Other",
        url: "sarcop_incident_support/other",
    },
    repeater: {
        name: "Repeater",
        url: "sarcop_incident_support/repeater",
    },
    safety_zone: {
        name: "Safety Zone",
        url: "sarcop_incident_support/safety_zone",
    },
    situation_update: {
        name: "Situation Update",
        url: "sarcop_incident_support/situation_update",
    },
    staging: {
        name: "Staging",
        url: "sarcop_incident_support/staging",
    },
}
